function isRecord(value: unknown): value is Record<string, unknown> {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
}

function valueType(value: unknown): string {
    if (value === null) return 'null';
    if (Array.isArray(value)) return 'array';
    return typeof value;
}

interface DigestPaperResponseShape {
    responseType: string;
    projectPaperType: string;
    paperType: string;
}

export class InvalidDigestPaperResponseError extends Error {
    readonly responseShape: DigestPaperResponseShape;

    constructor(responseShape: DigestPaperResponseShape) {
        super('Invalid digest paper response structure.');
        this.name = 'InvalidDigestPaperResponseError';
        this.responseShape = responseShape;
    }
}

export function validateDigestPaperResponse(value: unknown): void {
    const projectPaper = isRecord(value) ? value.project_paper : undefined;
    const paper = isRecord(projectPaper) ? projectPaper.paper : undefined;

    if (!isRecord(value) || !isRecord(projectPaper) || !isRecord(paper)) {
        // Fixed type labels only: never retain response values or arbitrary keys in telemetry.
        throw new InvalidDigestPaperResponseError({
            responseType: valueType(value),
            projectPaperType: valueType(projectPaper),
            paperType: valueType(paper),
        });
    }
}
